import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/profissional`;
export const createProfissional = async (profissional) => {
  return await axios.post(`${httpUrl}/create`, profissional).then((response) => response);
};

export const getProfissional = async (obj) => {
  return await axios
    .get(`${httpUrl}/list`, {
      params: obj,
    })
    .then((response) => response);
};

export const getListaProfissionaisResumida = async () => {
  return await axios.get(`${httpUrl}/lista-resumida`).then((response) => response);
};

export const getProfissionalById = async (id) => {
  return await axios.get(`${httpUrl}/${id}`).then((response) => response);
};

export const getProfissionalByCpf = (cpf) => {
  return axios.get(`${httpUrl}/cpf/${cpf}`, null, { ignoreInterceptors: true }).then((response) => response);
};

export const getProfRelatorio = async (params) => {
  return await axios
    .get(`${httpUrl}/consulta-relatorio`, {
      params: params,
    })
    .then((response) => response);
};

export const getQtdProfissionalAtivo = async () => {
  return await axios.get(`${httpUrl}/count-profissionais-ativos`).then((response) => response);
};

export const getQtdProfissionalPorTipo = async (form) => {
  return await axios.post(`${httpUrl}/list-profissionais-ativos-por-tipo`, form).then((response) => response);
};

export const gerarRelatorioProfissionalQtdeAtendimento = async (filtro) => {
  return await axios.post(`${httpUrl}/list-qtde-atendimento`, filtro).then((response) => response);
};

export const gerarRelatorioProfissionalQtdeAtendimentoAgrupadoPorMesAno = async (filtro) => {
  return await axios.post(`${httpUrl}/list-qtde-atendimento-agrupado-por-mes-ano`, filtro).then((response) => response);
};
